module.exports = __webpack_public_path__ + "img/009.700f00fe.jpg";